import React, {Component} from 'react';
import {Row, Col } from "reactstrap";
import {inject, observer} from "mobx-react/index";
import CardDetalhe from "../../comum/components/CardDetalhe";

@inject("store")
@observer
export default class DetalhesServico extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return(
            <Col xs={12} className="container-card-detalhe">
                <div className="pb-3 pt-3">
                    <h4>{this.props.titulo}</h4>
                    <Row className="m-0 no-gutters">
                        <Col sm={4}>
                            <CardDetalhe titulo={"Código"}
                                         desc={[this.props.row.OsId]}
                                         pt="pt-2"
                                         pb="pb-2"
                            />
                        </Col>
                        <Col sm={4}>
                            <CardDetalhe titulo={"Placa"}
                                         desc={[this.props.row.Placa]}
                                         pt="pt-2"
                                         pb="pb-2"
                            />
                        </Col>
                        <Col sm={4}>
                            <CardDetalhe titulo={"Agendado por"}
                                         desc={[this.props.row.LoginAgend]}
                                         pt="pt-2"
                                         pb="pb-2"
                                         />
                        </Col>
                    </Row>
                </div>
            </Col>)
    }
}


// WEBPACK FOOTER //
// ./src/modules/acompanhamentoservico/components/DetalhesServicos.js